import { Pipe, PipeTransform } from '@angular/core';
import {
  conferenceRegistrationSectionNameMap,
  ConferenceRegistrationStepName,
  ConferenceStepsConfigurationObject,
} from '@ag-common-lib/public-api';
import { isEmpty } from 'lodash';

@Pipe({
  name: 'conferenceStepTitle',
})
export class ConferenceStepsTitlePipe implements PipeTransform {
  transform(configurations: ConferenceStepsConfigurationObject, stepName: ConferenceRegistrationStepName): string {
    const defaultTitle = conferenceRegistrationSectionNameMap.get(stepName)?.title;
    if (!isEmpty(configurations) || !stepName) {
      return defaultTitle;
    }

    const conferenceStepTitle = configurations?.[stepName]?.title;
    return conferenceStepTitle ?? defaultTitle;
  }
}
